<template>
  <div class="my-buildings">
    <!-- User Statistics -->
    <div class="statistics-section mb-5">
      <h3>Your Building Statistics</h3>
      <div v-if="loadingStats" class="text-center py-4">
        <circle-loader :size="30"></circle-loader>
      </div>
      <building-statistics 
        v-else
        :stats="userStats"
        :show-creator-stats="false"
      />
    </div>

    <!-- Enhanced Building Table -->
    <div class="table-section">
      <h3>Your Buildings</h3>
      <enhanced-building-table
        :api-endpoint="'/services/v2/buildings/user'"
        :show-creator-column="false"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import CircleLoader from '@/components/CircleLoader'
import BuildingStatistics from '@/components/BuildingStatistics'
import EnhancedBuildingTable from '@/components/EnhancedBuildingTable'

export default {
  name: 'MyBuildingsPage',
  components: { 
    CircleLoader, 
    BuildingStatistics, 
    EnhancedBuildingTable 
  },
  data() {
    return {
      userStats: {},
      loadingStats: false
    }
  },
  methods: {
    async loadUserStats() {
      this.loadingStats = true
      try {
        const response = await axios.get('/services/v2/buildings/stats/user')
        this.userStats = response.data
      } catch (error) {
        console.error('Error loading user stats:', error)
        this.$bvToast.toast('Error loading statistics', {
          title: 'Error',
          variant: 'danger'
        })
      } finally {
        this.loadingStats = false
      }
    }
  },
  async mounted() {
    await this.loadUserStats()
  }
}
</script>

<style lang="scss" scoped>
.my-buildings {
  .statistics-section {
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 2rem;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);

    h3 {
      color: #495057;
      margin-bottom: 1.5rem;
      font-weight: 600;
    }
  }

  .table-section {
    h3 {
      color: #495057;
      margin-bottom: 1.5rem;
      font-weight: 600;
    }
  }
}
</style>
